import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 512 512' className={className}>
      <g transform='translate(16.006276, 0.000000)' fill={fillColor}>
        <polygon points='360.384 0 182.698667 311.274667 297.194667 512 416.810667 512 302.314667 311.274667 480 0' />
        <polygon points='133.226667 96 20.4586667 96 85.696 210.901333 0 352 112.768 352 198.464 210.901333' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
